import X from 'components/Icons/X'
import withCondition from 'components/withCondition'
import styled from 'styled-components'
import { fontWeightBold, grayLightest } from 'utils/style-utils'

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export const StyledHeaderText = styled.h6`
  margin: 0;
  font-size: 1.25rem;
  font-weight: ${fontWeightBold};
  pointer-events: none;
`

const CloseIcon = styled(X)`
  cursor: pointer;
  fill: ${grayLightest};
`

export const StyledCloseIcon = withCondition(CloseIcon)
